module.exports = __webpack_public_path__ + "static/img/coupon_bg_zh.6bf41ada.png";